import React, { useState, useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import connect from 'react-redux/es/connect/connect'
import { Helmet } from 'react-helmet'

import Button from '../components/Button/Button'
import SelectField from '../components/SelectField'
import CategoryWidget from '../components/CategoryWidget/CategoryWidget'
import XText from '../components/XText/XText'
import HelpForm from '../components/HelpForm/HelpForm'
import NewsAndArticles from '../components/NewsAndArticles/NewsAndArticles'
import QuestionsRemain from '../components/QuestionsRemain/QuestionsRemain'
import OurWork from '../components/OurWork/OurWork'
import Advantages from '../components/Advantages/Advantages'
import ModelSelection from '../components/ModelSelection/ModelSelection'
import AboutUs from '../components/AboutUs/AboutUs'

import TeslaIcon from '../icons/tesla.png'
import BmwIcon from '../icons/bmw.png'

import { t } from '../services/storage'
import { addToCart, removeFromCart } from '../db/Cart'
import { changeView } from '../db/View'
import { searchAll, changeCLICK, changeFilters } from '../db/search'
import { httpPost } from '../services/http'
import { getCommonLDScripts } from '../services/seo'

import { useFilters } from '../hooks/useFilters'
import { useCustomPagination } from '../hooks/useCustomPagination'
import { useQueryParams } from '../hooks/useQueryParams'

import './home-page.css'

const HomePage = (props) => {
  const {
    user,
    search,
    history,
  } = props
  const [state, setState] = useState({ pages: [] })

  useEffect(() => {
    httpPost('page/getAll')
      .then((resp) => {
        setState((prevState) => ({ ...prevState, pages: resp.data || [] }))
      })
  }, [])

  const { changeQueryString } = useQueryParams(props)

  const {
    filtersData,
    search: searchAction,
    changeSelected,
    filtersOptions: {
      categoryOptions,
      brandOptions,
      brandSearchOptions,
      modelOptions,
      groupOptions,
      subGroupOptions
    },
  } = useFilters({ ...props, changeQueryString, resetData: () => {} })

  const {
    list: paginatedCategories,
    prevDisabled,
    prevOnClick,
    nextDisabed,
    nextOnClick,
  } = useCustomPagination({ list: filtersData.categories, per: 6 })

  const {
    list: newsList,
    prevDisabled: prevNewsButtonDisabled,
    prevOnClick: prevNewsButtonClick,
    nextDisabed: nextNewsButtonDisabled,
    nextOnClick: nextNewsButtonClick,
  } = useCustomPagination({ list: state.pages || [], per: 2 })

  useEffect(() => {
		const {
			logged,
			phone,
			name,
			Name: username,
		} = user || {}

    if (logged) {
			setState((prevState) => ({
        ...prevState,
				phone,
				name,
				username,
			}))
		}
  }, [])

  return (
    <>
    <Helmet script={getCommonLDScripts()}>
      <meta name='author' content='Xpart' />
      <meta name="robots" content="index,follow" />
      <meta name='theme-color' content='#1a7fc8' />
      <meta name='local' property='og:local' content='uk_UA' />
      <meta name='site_name' property='og:site_name' content={window.location.hostname} />
    </Helmet>
    <section className='select-part'>
      <div className='section__content'>
        <div className='titles'>
          <div className='title'>Підбір і доставка</div>
          <div className='subtitle'>Автозапчастин</div>
        </div>
        <div className='select-section'>
          <div className='select-container'>
            <SelectField
              onChange={(option) => changeSelected('car', option.value)}
              options={brandOptions}
              placeholder='Оберіть марку'
              value={brandOptions.find(({ value }) => value._id === filtersData.car || value.search === search.filters.car)}
            />
            <SelectField
              onChange={(option) => changeSelected('model', option.value)}
              options={modelOptions}
              placeholder='Оберіть модель'
              value={modelOptions.find(({ value }) => value === filtersData.model)}
            />
          </div>
          <div className='select-container'>
            <SelectField
              options={categoryOptions}
              placeholder='Оберіть категорію'
              onChange={(option) => changeSelected('category', option.value)}
              value={categoryOptions.find(({ value }) => value === filtersData.category)}
            />
            <SelectField
              options={groupOptions}
              placeholder='Оберіть групу'
              onChange={(option) => changeSelected('type', option.value)}
              value={categoryOptions.find(({ value }) => value === filtersData.type)}
            />
          </div>
          <div className='select-container'>
            <SelectField
              options={subGroupOptions}
              placeholder='Оберіть під групу'
              onChange={(option) => changeSelected('subType', option.value)}
              value={categoryOptions.find(({ value }) => value === filtersData.subType)}
            />
            <Button
              onClick={() => {
                history.push('/catalog')
                searchAction()
              }}
            >
              Підібрати
            </Button>
          </div>
        </div>
        <img className='tesla' src={TeslaIcon} alt="tesla" />
        <img className='bmw' src={BmwIcon} alt="bmw" />
      </div>
    </section>

    <section className='select-categories'>
      <div className='section__content'>
        <div className='section__title'>
          Вибір<XText>категорії</XText>
        </div>
        <div className='select-categories__list'>
          {paginatedCategories.map((item) => (
            <CategoryWidget key={item.id} itemId={item.id} name={item.Name} />
          ))}
        </div>
        <div className='flex-container--bottom-70 flex-container--center'>
          <Button.Arrow
            left
            disabled={prevDisabled}
            onClick={prevOnClick}
          />
          <Button.Arrow
            disabled={nextDisabed}
            onClick={nextOnClick}
          /> 
        </div>
      </div>
    </section>

    <Advantages />
    <div className='main-background'>
      <ModelSelection models={brandSearchOptions} />
      <HelpForm />
      <OurWork />
    </div>

    <section className='flex-container--bottom-70'>
      <div className='section__content'>
        <div className='section__title flex-container--bottom-70'>
          <XText>Новини</XText> та стат’ї
        </div>
        <div className='flex-container--wrap'>
          <NewsAndArticles pages={newsList} />
        </div>
        <div className='flex-container--top-70 flex-container--center'>
          <Button.Arrow
            disabled={prevNewsButtonDisabled}
            onClick={prevNewsButtonClick}
            left
          />
          <Button.Arrow
            disabled={nextNewsButtonDisabled}
            onClick={nextNewsButtonClick}
          />
        </div>
      </div>
    </section>

    <AboutUs />
    <QuestionsRemain className='questions-remain--on-home-page questions-remain--without-margins' />
    </>
  )
}

function mapStateToProps(state) {
	return {
		user: state.user,
		cart: state.cart,
		view: state.view,
		translate: state.translate,
		search: state.search,
		ex: state.ex
	}
}
function matchDispatchToProps(dispatch) {
	return bindActionCreators({
    t,
    addToCart,
    removeFromCart,
    changeView,
    searchAll,
    changeCLICK,
    changeFilters
  }, dispatch)
}

export default withRouter(connect(mapStateToProps, matchDispatchToProps)(HomePage))
